"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FulfilledImageButtonGroupBase = exports.FulfilledImageButtonGroup = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireDefault(require("react"));
var _i18n = require("../../../i18n/i18n");
var _useTheme = require("../../../theme/utils/useTheme");
var _ButtonGroupStyled = require("../styled/ButtonGroupStyled");
var _RemoveButtonStyled = require("../styled/RemoveButtonStyled");
var _RevertButtonStyled = require("../styled/RevertButtonStyled");
var _imageUploaderTheme = require("../styled/imageUploaderTheme");
var _ImageBrowse = require("./ImageBrowse");
const FulfilledImageButtonGroupBase = _ref => {
  let {
    acceptableMimeTypes,
    clientId,
    defaultImageSrc,
    fulfilledState,
    i18n,
    imagePreviewUrl,
    isDisabled,
    isLogoUploader,
    onChange,
    onRemove
  } = _ref;
  const showPreviousImage = fulfilledState === "fulfilled" || imagePreviewUrl && !fulfilledState;
  const showRevertButton = showPreviousImage && defaultImageSrc && isLogoUploader;
  const showRemoveButton = showPreviousImage && (!defaultImageSrc || !isLogoUploader);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_ButtonGroupStyled.ButtonGroupStyled, {
    orientation: "row",
    space: "xSmall",
    themeMode: themeMode
  }, showRevertButton && /*#__PURE__*/_react.default.createElement(_RevertButtonStyled.RevertButtonStyled, {
    appearance: _imageUploaderTheme.imageUploaderTheme.revertButton.appearance(themeMode),
    clientId: (0, _lodestarUtils.getClientId)(clientId, "revert"),
    onClick: onRemove,
    size: "medium",
    themeMode: themeMode
  }, i18n._( /*i18n*/"Revert to default")), showRemoveButton && /*#__PURE__*/_react.default.createElement(_RemoveButtonStyled.RemoveButtonStyled, {
    clientId: (0, _lodestarUtils.getClientId)(clientId, "remove"),
    isDisabled: isDisabled,
    onClick: onRemove,
    themeMode: themeMode,
    "aria-label": i18n._( /*i18n*/"Remove")
  }, themeMode !== "ursa-light" ? i18n._( /*i18n*/"Remove") : null), /*#__PURE__*/_react.default.createElement(_ImageBrowse.ImageBrowse, {
    buttonAppearance: _imageUploaderTheme.imageUploaderTheme.changeButton(themeMode),
    accept: acceptableMimeTypes.join(","),
    browseButtonTextId: "Change",
    buttonSize: "small",
    isDisabled: isDisabled,
    onChange: onChange,
    clientId: clientId
  }));
};
exports.FulfilledImageButtonGroupBase = FulfilledImageButtonGroupBase;
const FulfilledImageButtonGroup = (0, _i18n.withI18n)(FulfilledImageButtonGroupBase);
exports.FulfilledImageButtonGroup = FulfilledImageButtonGroup;
//# sourceMappingURL=FulfilledImageButtonGroup.js.map